<template>
  <div class="border-b border-gray-200 bg-white py-4">
    <div
      class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 sm:flex sm:items-center sm:justify-between"
    >
      <div class="flex-1 min-w-0">
        <h1 class="text-xl font-medium leading-6 text-gray-900 sm:truncate">
          {{ title }}
        </h1>
        <slot name="title"></slot>
      </div>
      <div class="mt-4 flex sm:mt-0 sm:ml-4" v-if="$slots.actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
